export const selection = {
  navigation: {
    backToHome: "Vissza a főoldalra",
    login: "Bejelentkezés"
  },
  hero: {
    title: "Válaszd ki, hogyan szeretnéd elkezdeni"
  },
  options: {
    existing: {
      title: "Már van weboldalam",
      description: "Add meg a weboldalad URL-jét, és az AI elemzi majd átalakítja a Bespire platformra",
      placeholder: "https://pelda.hu",
      button: "Elemzés és átalakítás"
    },
    new: {
      title: "Új weboldalt szeretnék",
      description: "Hozz létre egy teljesen új weboldalt AI segítségével néhány kérdés megválaszolásával",
      button: "Kezdjük el"
    }
  },
  analysis: {
    title: "Weboldalad elemzése folyamatban",
    description: "Az AI most elemzi a weboldalad és felkészíti az átköltöztetéshez",
    steps: [
      {
        icon: "search",
        title: "Weboldal letöltése",
        description: "Az AI letölti és elemzi a weboldaladat"
      },
      {
        icon: "brain",
        title: "Tartalom elemzése",
        description: "Az AI megérti a weboldal struktúráját és tartalmát"
      },
      {
        icon: "download",
        title: "Átalakítás előkészítése",
        description: "Az AI felkészíti az átalakítást a Bespire platformra"
      }
    ]
  },
  benefits: [
    {
      title: "AI-vezérelt",
      description: "Használd az AI-t a weboldal elkészítéséhez és kezeléséhez"
    },
    {
      title: "Gyors indítás",
      description: "Percek alatt készen áll a weboldal"
    },
    {
      title: "Profi eredmény",
      description: "Professzionális weboldal egyedi igényekre szabva"
    }
  ]
};
